import {connect} from 'react-redux';
import LabelHello from './LabelHello';

const mapStateToProps = ({
                           user: {user: {attributes: {name}}}
                         }) => ({
  name
});

export default connect(
  mapStateToProps,
  null
)(LabelHello);
